<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'App',
  components: {},
  watch: {
    '$vuetify.breakpoint.width'(width){
      this.setMobile(width);
    }
  },
  data: () => ({
    //
  }),
  mounted(){
    this.setMobile(this.$vuetify.breakpoint.width);
  },
  methods: {
    ...mapMutations(['setMobile']),
  }
};
</script>
